import type { ComponentType, ReactNode } from 'react';
import type { StorefrontCatalogItem, StorefrontHome, StorefrontProduct } from '@storeo/api-client';

import LuminaCinemaCatalog from './lumina-cinema/Catalog';
import LuminaCinemaProduct from './lumina-cinema/Product';
import CyberNoirCatalog from './cyber-noir/Catalog';
import CyberNoirProduct from './cyber-noir/Product';
import ObsidianLuxuryCatalog from './obsidian-luxury/Catalog';
import ObsidianLuxuryProduct from './obsidian-luxury/Product';
import PortalVslCatalog from './portal-vsl/Catalog';
import PortalVslProduct from './portal-vsl/Product';
import CleanOfferCatalog from './clean-offer/Catalog';
import CleanOfferProduct from './clean-offer/Product';
import FastGridCatalog from './fast-grid/Catalog';
import FastGridProduct from './fast-grid/Product';

/** `apiBase` — cada app resolve a própria URL da API (Next: `process.env.NEXT_PUBLIC_API_BASE_URL`;
 *  Vite: `import.meta.env.VITE_API_BASE_URL`) e passa pronta, porque este pacote não pode importar
 *  nada específico de bundler. */
export type CatalogProps = { data: StorefrontHome; apiBase: string };
export type ProductProps = {
  data: StorefrontProduct;
  apiBase: string;
  /** Outros produtos publicados da loja, pra seção "Mais da loja" na página de produto. */
  relatedProducts?: StorefrontCatalogItem[];
  /** Onde o app real planta o formulário de checkout funcional (Next-aware) — sem isso, o botão
   *  de compra vira link pra `/p/:slug/checkout`. */
  checkoutSlot?: ReactNode;
};

type Template = { Catalog: ComponentType<CatalogProps>; Product: ComponentType<ProductProps> };

export const LUMINA_TEMPLATES = {
  'lumina-cinema': { Catalog: LuminaCinemaCatalog, Product: LuminaCinemaProduct },
  'cyber-noir': { Catalog: CyberNoirCatalog, Product: CyberNoirProduct },
  'obsidian-luxury': { Catalog: ObsidianLuxuryCatalog, Product: ObsidianLuxuryProduct },
  'portal-vsl': { Catalog: PortalVslCatalog, Product: PortalVslProduct },
  'clean-offer': { Catalog: CleanOfferCatalog, Product: CleanOfferProduct },
  'fast-grid': { Catalog: FastGridCatalog, Product: FastGridProduct },
} satisfies Record<string, Template>;

export type LuminaTemplateKey = keyof typeof LUMINA_TEMPLATES;

/** `store.template` picks the look; um valor desconhecido (ou legado — minimalista/comunidade/
 *  oferta, que continuam vivendo só em `apps/storefront`) cai pro lumina-cinema. */
export function luminaTemplateFor(name: string): Template {
  return (LUMINA_TEMPLATES as Record<string, Template | undefined>)[name] ?? LUMINA_TEMPLATES['lumina-cinema'];
}

export * from './shared';
export * from './sections';
export { Countdown } from './Countdown';
